import "./CardiacProcedures.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import { Link } from "@/components/common/Link";
export default function CardiacProceduresPage() {
  return <div>
      <Header />
      <section className="bg-[var(--color-dark-navy)] pt-32 pb-16 px-6 lg:px-12 font-default">
        <p className="text-sm uppercase tracking-widest text-red-500 mb-4">Services</p>
        <h1 className="font-bold text-3xl md:text-4xl uppercase tracking-tight text-white mb-6">Life-Changing Cardiac Procedures</h1>
        <p className="text-lg text-soft-gray max-w-3xl">If you've had a serious heart condition, you understand how it can drastically affect your quality of life. At Florida Premier Cardiology, Dr. Carrillo-Jimenez provides personalized cardiovascular care and performs a range of cardiac procedures based on each patient's needs.</p>
      </section>
      <section className="bg-background text-foreground py-16 px-6 lg:px-12 font-default">
        <div className="max-w-3xl mx-auto space-y-10">
          <div>
            <h2 className="font-bold text-2xl md:text-3xl uppercase tracking-tight mb-4 text-red-500">Procedures We Offer</h2>
            <ul className="list-disc list-inside text-base text-soft-gray leading-relaxed space-y-2">
              <li>Cardiac catheterization</li>
              <li>Coronary angioplasty</li>
              <li>Coronary stent placement</li>
              <li>Transesophageal echocardiography (TEE)</li>
              <li>Transcatheter aortic valve replacement (TAVR)</li>
              <li>Watchman procedure</li>
              <li>MitraClip procedure for valvular disease</li>
            </ul>
          </div>
          <div>
            <h2 className="font-bold text-2xl md:text-3xl uppercase tracking-tight mb-4 text-red-500">Get an Expert Evaluation and On-Site Testing</h2>
            <p className="text-base text-soft-gray leading-relaxed">In cardiology, proper screening and an accurate diagnosis are paramount. At our Boynton Beach and Delray Beach clinics, Dr. Carrillo-Jimenez can provide you with an evaluation using advanced technology and convenient on-site testing.</p>
            <p className="text-base text-soft-gray leading-relaxed mt-4">Our goal is to provide you with modern cardiovascular care focused on achieving the best possible results. For educational videos, <a href="https://www.vascular.abbott/us/education-and-training/hcp-educational-resources.html" target="_blank" rel="noopener noreferrer" className="text-red-500 underline">click here</a>.</p>
          </div>
        </div>
      </section>
      <section className="bg-[var(--color-dark-navy)] py-16 px-6 lg:px-12 font-default text-center">
        <p className="text-white text-lg max-w-2xl mx-auto mb-8">If you have been advised to consider a cardiac procedure, schedule an appointment with us today to discuss your options.</p>
        <Link to="/contact-us/" className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-10 py-5 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200">Contact Us</Link>
      </section>
      <Footer />
    </div>;
}
